/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type ToDoPillFilters = typeof ToDoPillFilters[keyof typeof ToDoPillFilters];


export const ToDoPillFilters = {
  All: 'All',
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  DueToday: 'DueToday',
  OverDue: 'OverDue',
  AssignedToMe: 'AssignedToMe',
} as const;
